export default "__VITE_ASSET__B88_49lN__"